import { render, staticRenderFns } from "./AdminPwChange.vue?vue&type=template&id=b0432766&scoped=true"
import script from "./AdminPwChange.vue?vue&type=script&lang=js"
export * from "./AdminPwChange.vue?vue&type=script&lang=js"
import style0 from "./AdminPwChange.vue?vue&type=style&index=0&id=b0432766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0432766",
  null
  
)

export default component.exports